module.exports = __webpack_public_path__ + "static/media/hand-rock.d463304a.svg";